class indicatorsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/indicators/:route',{},{
			getIndicators:{
				method:'GET',
				params : {}
			},
			getIndicatorDetails:{
				method:'GET',
				params : {
					route: 'id'
				}
			},
			saveIndicators:{
				method:'POST',
				params : {}
			},
			updateIndicators:{
				method:'PUT',
				params : {}
			},

		});

		return {
			services : services
		};
	}
}

indicatorsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.indicatorsServices', [])
.service('indicatorsServices', indicatorsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/indicators/indicatorsServices.js